<template>
    <div class="followed-project-container">
      <div class="followed-table-container">
        <h2 class="section-title">Followed Projects</h2>
      <div v-if="loading">
        Loading followed projects...
      </div>
      <div v-if="error" class="error-message">
        {{ error }}
      </div>
      <table class="project-table" v-if="followedProjects.length">
        <thead>
          <tr>
            <th>Project Name</th>
            <th>Producer</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="project in followedProjects" :key="project.projectID">
            <td>
              <router-link :to="`/feedback/${project.projectID}/dashboard`" class="project-link">
                {{ project.projectName }}
              </router-link>
            </td>
            <td>{{ project.producers }}</td>
            <td>
              <button class="delete-button" @click="unfollowProject(project.projectID)">
                Unfollow
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else>
        <p><strong>🤔 You are not following any projects.</strong><br>Head to a project page and click <strong>+Follow project</strong> in the top-right corner to add it to your list.</p>
        <div class="follow-button-container">
          <button class="follow-button">+Follow project</button>
        </div>
      </div>
    </div>
    </div>
  </template>
  
  <script>
  import { db } from "../firebaseConfig";
  import { getAuth } from "firebase/auth";
  import { doc, getDoc, updateDoc, arrayRemove } from "firebase/firestore";
  
  export default {
    name: "ProfileFollowedProjects",
    data() {
      return {
        followedProjects: [],
        loading: false,
        error: null,
        userId: null,
        userFollowArray: []
      };
    },
    created() {
      this.fetchFollowedProjects();
    },
    methods: {
      async fetchFollowedProjects() {
        this.loading = true;
        try {
          const auth = getAuth();
          const user = auth.currentUser;
          if (!user) {
            this.error = "User not logged in.";
            return;
          }
          this.userId = user.uid;
          // Fetch the current user's document to get the projectFollow array
          const userRef = doc(db, "users", this.userId);
          const userSnap = await getDoc(userRef);
          if (userSnap.exists()) {
            const userData = userSnap.data();
            this.userFollowArray = userData.projectFollow || [];
          } else {
            this.error = "User document not found.";
            return;
          }
          // Retrieve project details for each followed project
          const projectPromises = this.userFollowArray.map(async (projectID) => {
            const projectRef = doc(db, "projects", projectID, "projectDetails", "details");
            const projectSnap = await getDoc(projectRef);
            if (projectSnap.exists()) {
              const projectData = projectSnap.data();
              // Retrieve the producer's fullName from the user's doc
              let producerFullName = "N/A";
              if (projectData.producers) {
                const producerRef = doc(db, "users", projectData.producers);
                const producerSnap = await getDoc(producerRef);
                if (producerSnap.exists()) {
                  const producerData = producerSnap.data();
                  producerFullName = producerData.fullName || "N/A";
                }
              }
              return {
                projectID,
                projectName: projectData.projectName || "Unnamed project",
                producers: producerFullName
              };
            }
            return null;
          });
          const projectResults = await Promise.all(projectPromises);
          // Filter out projects that weren't found
          this.followedProjects = projectResults.filter((project) => project !== null);
        } catch (err) {
          console.error("Error fetching followed projects:", err);
          this.error = "Error fetching followed projects.";
        } finally {
          this.loading = false;
        }
      },
      async unfollowProject(projectID) {
        try {
          const userRef = doc(db, "users", this.userId);
          await updateDoc(userRef, {
            projectFollow: arrayRemove(projectID)
          });
          // Update local state after unfollowing the project
          this.followedProjects = this.followedProjects.filter(proj => proj.projectID !== projectID);
          this.userFollowArray = this.userFollowArray.filter(id => id !== projectID);
        } catch (err) {
          console.error("Error unfollowing project:", err);
          this.error = "Error unfollowing project.";
        }
      }
    }
  };
  </script>
  
  <style src="./listingTables.css" scoped></style>
  <style src="./elements.css" scoped></style>
  <style scoped> 
  .followed-project-container {
    max-width: 1200px;
    margin: 0 auto;
    font-family: "Poppins", sans-serif;
    color: #111827;
  }

  .followed-table-container {
    max-width: 850px;
    background-color: #fff;
    border: 1px solid #C9BF9B;
    box-shadow: 0px 4px 4px #c9bf9b54;
    border-radius: 30px;
    padding: 10px 30px 10px 30px;
    color: #111827;
    margin-bottom: 30px;
  }
.follow-button-container {
    display: flex;
    justify-content: center;
    margin: 20px 0px 40px 0px;
  }

  .follow-button {
    background-color: #EA845A;
    border: none;
    color: #f8f7f3;
    padding: 8px 16px;
    font-size: 14px;
    cursor: default;
    border-radius: 10px;
    transition: box-shadow 1s ease;
    box-shadow: 0px 0px 12px 3px #FFB681;
  }
  .follow-button:hover {
    box-shadow: 0px 0px 5px 1px #FFB681;
  }
</style>